import { Coordinate, PathSegment } from '../types/types'

export const getIntervalDistance = (pathCoords: Array<PathSegment>) => {
  const intDist: number[] = [0];

  pathCoords.forEach((coords) => {
    const dist = (coords.distance) / 1000
    if (dist) {
      intDist.push(dist);
    }
  });


  return intDist;
}

export const getCoordsPoints = (pathCoords: Array<PathSegment>) => {
  const points: Coordinate[] = [];

  pathCoords.forEach((coords, i) => {
    const firstPoint = coords.path[0];

    if (firstPoint) {
      points.push(firstPoint);
    }

    if (i === pathCoords.length - 1) {
      const lastPoint = coords.path[coords.path.length - 1];
      if (lastPoint && lastPoint !== firstPoint) {
        points.push(lastPoint);
      }
    }
  });

  return points;
}
